import { abstract } from "ol/util";
import { ErrorLogFile } from "./errorLog";

export class CalculationProgressModel{
    message: string;
    loadedPercentage: number;
    calculationName: string;
    calculationType: string;
    calculationId: number;
    projectId: number;
    projectName: string;
    // used in terrain validation only
    terrainCorruptedFiles: string[];
    //used in import project only
    storageError: string;
    // used in get log file data only
    logFilesData: string;


    public static readonly COMPLETED_CALCULATION: string = "COMPLETED_CALCULATION";
    public static readonly CANCEL_CALCULATION: string = "CANCEL_CALCULATION";
    public static readonly ERROR_FLAG: number = -1;
    public static readonly VALID_FLAG: number = -2;
    public static readonly CANCEL_FLAG: number = -3;

    public static readonly INSUFFICIENT_STORAGE_ON_CALCS: string = "INSUFFICIENT_STORAGE_ON_CALCS";
    public static readonly INSUFFICIENT_STORAGE_ON_TERRAINS: string = "INSUFFICIENT_STORAGE_ON_TERRAINS";
    public static readonly INSUFFICIENT_STORAGE_ON_BOTH: string = "INSUFFICIENT_STORAGE_ON_BOTH";
    public static readonly ERROR_ON_PROJECT_IMPORT: string = "ERROR_ON_PROJECT_IMPORT";


    constructor(){}
}
